import { useEffect, useState } from "react";
import { Download, FileText, FileType } from "lucide-react";
import { toast } from "sonner";
import api, { API } from "@/lib/api";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Overline } from "@/components/Bits";

export default function Resources() {
  const [resources, setResources] = useState([]);

  useEffect(() => {
    api.get("/resources").then(({ data }) => setResources(data)).catch(() => {});
  }, []);

  const handleDownload = (r) => {
    const url = `${API}/resources/${r.slug}/download`;
    const a = document.createElement("a");
    a.href = url;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
    toast.success(`Downloading "${r.title}"…`);
  };

  return (
    <div data-testid="resources-page">
      <PageHero
        overline="Free Kingdom Resources"
        title={<>Tools to strengthen your <span className="font-accent text-gold-gradient italic">life & leadership.</span></>}
        subtitle="Practical, free resources designed to strengthen your spiritual life, leadership capacity, and professional effectiveness."
      />

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 py-24">
        <Reveal className="mb-14"><Overline>Free Downloads</Overline></Reveal>
        <div className="grid gap-px bg-gold-500/15 border border-gold-500/15 md:grid-cols-2">
          {resources.map((r, i) => (
            <Reveal key={r.slug} delay={(i % 2) * 0.05}>
              <div className="group flex flex-col justify-between bg-ink p-9 transition-colors duration-500 hover:bg-ink-paper h-full" data-testid={`resource-${r.slug}`}>
                <div>
                  <div className="flex items-center gap-3">
                    {r.format === "PDF" ? <FileText size={18} className="text-gold-500" /> : <FileType size={18} className="text-gold-500" />}
                    <span className="text-[10px] uppercase tracking-[0.25em] text-gold-500">{r.category} · {r.format}</span>
                  </div>
                  <h3 className="mt-5 font-serif text-2xl text-white">{r.title}</h3>
                  <p className="mt-3 text-sm text-white/60 leading-relaxed">{r.description}</p>
                </div>
                <button
                  onClick={() => handleDownload(r)}
                  data-testid={`download-${r.slug}`}
                  className="mt-7 inline-flex w-fit items-center gap-2 border border-gold-500/40 px-5 py-2.5 text-xs uppercase tracking-[0.15em] text-white/85 hover:border-gold-400 hover:text-gold-300 hover:gap-3 transition-all duration-300"
                >
                  <Download size={14} /> Download Free
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
